"use client"

import {useSearchParams} from "next/navigation"
import GdprRightsForm from "@/app/components/gdpr/GdprRightsForm"
import {GDPR_RIGHT_QUERY_PARAM, isGdprRightSlug} from "@/app/constants/gdpr-rights"

// Deep links from the CGU / privacy policy preselect the right: /mes-droits-rgpd?droit=opposition (honoured once the other rights are public)
export default function GdprRightsFormFromQuery({allRights}: {allRights?: boolean}) {
    const searchParams = useSearchParams()
    const requestedRight = searchParams?.get(GDPR_RIGHT_QUERY_PARAM)

    return <GdprRightsForm initialRight={isGdprRightSlug(requestedRight) ? requestedRight : undefined} allRights={allRights} />
}
